import api from './api';
import { Beneficiary, BeneficiaryFormData } from '../interfaces/beneficiary';

const ENDPOINT = '/beneficiaries/';

export const getBeneficiaries = async () => {
  // Log para depuración
  console.log("[BENEFICIARIES] baseURL:", api.defaults.baseURL, "ENDPOINT:", ENDPOINT);
  const response = await api.get<Beneficiary[]>(ENDPOINT);
  return response.data;
};

export const getBeneficiary = async (id: number) => {
  const response = await api.get<Beneficiary>(`${ENDPOINT}${id}/`);
  return response.data;
};

export const createBeneficiary = async (beneficiaryData: BeneficiaryFormData) => {
  const response = await api.post<Beneficiary>(ENDPOINT, beneficiaryData);
  return response.data;
};

export const updateBeneficiary = async (id: number, beneficiaryData: BeneficiaryFormData) => {
  const response = await api.put<Beneficiary>(`${ENDPOINT}${id}/`, beneficiaryData);
  return response.data;
};

export const deleteBeneficiary = async (id: number) => {
  await api.delete(`${ENDPOINT}${id}/`);
  return true;
};

// Función para filtrar beneficiarios
export const searchBeneficiaries = async (query: string) => {
  const response = await api.get<Beneficiary[]>(`${ENDPOINT}?search=${query}`);
  return response.data;
}; 